import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { ICasesService } from "services/CasesService";
import { CaseModel, NewCaseModel } from "services/api/cplapi/CPLAPI";
import { RootState } from "setup";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import { container } from "setup/dependency/inversify.config";
import { getComments } from "app/modules/shared/commentThread/components/CommentThreadSlice";

const initialState = {
  Case: new CaseModel({ title: "", adHocEmailAddress: "" }),
  EditingCase: false,
  LoadingCase: false,
  CreatedCaseID: 0,
};

export const casesSlice = createSlice({
  name: "cases",
  initialState,
  reducers: {
    resetData: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCase.pending, (state) => {
        state.LoadingCase = true;
      })
      .addCase(createCase.pending, (state) => {
        state.EditingCase = true;
      })
      .addCase(updateCase.pending, (state) => {
        state.EditingCase = true;
      })
      .addCase(getCase.rejected, (state) => {
        state.LoadingCase = false;
      })
      .addCase(createCase.rejected, (state) => {
        state.EditingCase = false;
        toast.error("Case failed to create");
      })
      .addCase(updateCase.rejected, (state) => {
        state.EditingCase = false;
        toast.error("Case failed to updated");
      })
      .addCase(getCase.fulfilled, (state, action) => {
        state.LoadingCase = false;
        state.Case = action.payload;
      })
      .addCase(createCase.fulfilled, (state, action) => {
        state.EditingCase = false;
        state.CreatedCaseID = action.payload;
        toast.success("Case created successfully");
      })
      .addCase(updateCase.fulfilled, (state) => {
        state.EditingCase = false;
        toast.success("Case updated successfully");
      });
  },
});

export const getCase = createAsyncThunk("Cases/GetCase", async (caseID: number) => {
  const casesService = container.get<ICasesService>(SERVICE_TYPES.CasesService);
  return await casesService.getCase(caseID);
});
export const createCase = createAsyncThunk("Cases/CreateCase", async (newCaseModel: NewCaseModel, thunkAPI) => {
  const casesService = container.get<ICasesService>(SERVICE_TYPES.CasesService);
  const createdCaseID = await casesService.createCase(newCaseModel);
  thunkAPI.dispatch(getCase(createdCaseID));
  return createdCaseID;
});

export const updateCase = createAsyncThunk("Cases/UpdateCase", async (caseModel: CaseModel, thunkAPI) => {
  const casesService = container.get<ICasesService>(SERVICE_TYPES.CasesService);
  await casesService.updateCase(caseModel);
  thunkAPI.dispatch(getComments(caseModel.commentThreadID!));
  thunkAPI.dispatch(getCase(caseModel.caseID!));
});

export const { resetData } = casesSlice.actions;

export const selectLoadingCase = (state: RootState) => {
  return state.case.LoadingCase;
};
export const selectEditingCase = (state: RootState) => {
  return state.case.EditingCase;
};
export const selectCreatedCaseID = (state: RootState) => {
  return state.case.CreatedCaseID;
};

export const selectCase = (state: RootState) => {
  return state.case.Case;
};

export default casesSlice.reducer;
